import React from "react";
import { Link } from "react-router-dom";
import StoreMap from "../Components/StoreMap";
import FactDice from "../Components/FactDice";
import "../about-store.css";

export default function About() {
  return (
    <main className="ab-page">
      <section className="ab-hero">
        <div className="ab-wrap company-hero-grid"><div className="company-hero-copy">
          <p className="ab-eyebrow">ABOUT TECHNOGENIOUS</p>
          <h1>
            Practical solutions.
            <br />
            <span>Built around your gaming machine.</span>
          </h1>
          <p>
            Technogenious Solutions Ltd. brings together electronic parts,
            gaming machines, and technical services from our home in Kingston,
            Jamaica.
          </p>
          <div className="ab-actions">
            <Link className="ab-primary" to="/products">
              Explore our products →
            </Link>
            <Link to="/contact">Meet us in Kingston</Link>
          </div>
        </div>
          <figure className="company-visual company-photo"><img src="/installations/installation-updated-03.jpg" alt="Three Technogenious American Roulette gaming machines installed side by side" /><figcaption>Our machines. Real locations. Jamaica.</figcaption></figure>
        </div>
      </section>
      <div className="ab-wrap ab-content">
        <section className="ab-story" aria-labelledby="ab-story-title">
          <div>
            <p className="ab-eyebrow">OUR STORY</p>
            <h2 id="ab-story-title">
              From an idea in Portmore
              <br />
              to a business in Kingston.
            </h2>
            <p>
              Sean Taylor founded Technogenious Solutions Ltd. in 2018. The
              business began in Portmore, St. Catherine, and later moved to Shop
              4B, 17 Molynes Road in Kingston.
            </p>
            <p>
              The company grew from Sean’s decision to turn an entrepreneurial
              idea into a business serving Jamaica’s gaming machine industry.
              That beginning still shapes our approach: understand the
              customer’s needs, find a practical solution, and support the
              machine beyond the initial purchase.
            </p>
            <p>
              Our work includes manufacturing, assembling, selling, repairing,
              installing, and leasing gaming machines and related components. We bring together machines, replacement parts, and
              technical support so customers can discuss their requirements with
              one team.
            </p>
          </div>
          <aside className="ab-mission" aria-labelledby="ab-mission-title">
            <p className="ab-eyebrow" id="ab-mission-title">
              OUR MISSION & VISION
            </p>
            <blockquote>
              “To provide Ingenious Business Solutions – Be Ready!”
            </blockquote>
            <p>
              Our vision is to establish and strengthen our position in the
              gaming machine industry through quality products, reliable
              service, and competitive prices. We aim to remain dependable,
              affordable, and responsive to changing technology.
            </p>
          </aside>
        </section>
        <section className="ab-visit" aria-labelledby="ab-licensing-title">
          <div>
            <p className="ab-eyebrow">BGLC LICENSING</p>
            <h2 id="ab-licensing-title">
              Licensed technical service provider.
            </h2>
            <p>
              Technogenious Solutions Ltd. is a BGLC-licensed technical
              service provider for gaming machines and related components. Our
              technical services include manufacturing, assembling, testing,
              repairing, selling, supplying, and installing gaming machines and
              related components.
            </p>
          </div>
          <Link className="ab-primary" to="/services">
            Explore our services →
          </Link>
        </section>
        <section
          className="ab-background"
          aria-labelledby="ab-experience-title"
        >
          <div>
            <p className="ab-eyebrow">WHAT WE BRING TO YOUR BUSINESS</p>
            <h2 id="ab-experience-title">More than a machine supplier.</h2>
            <p>
              Our catalogue brings together electronic parts and service
              supplies sourced from local and international suppliers. From a
              replacement switch to a complete gaming machine, our team can help
              you choose the model, configuration, and components your project
              requires.
            </p>
            <p>
              We work with customers purchasing machines and parts, as well as
              licensed bar owners and other eligible operators exploring
              leasing. Installation, maintenance, and repair support are part of
              that longer-term relationship.
            </p>
          </div>
          <aside className="ab-partner">
            <p className="ab-eyebrow">PYRAMID TECHNOLOGIES</p>
            <h3>Sales & service support in Jamaica</h3>
            <p>
              Pyramid Technologies lists Technogenious Solutions in its
              international distributor and service-centre directory for
              Jamaica. Speak with us about Pyramid bill acceptors, ticket
              printers, replacement parts, and servicing requirements.
            </p>
            <a
              href="https://pyramidacceptors.com/contact-usa"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Pyramid’s directory ↗
            </a>
          </aside>
        </section>
        <section className="ab-offer" aria-labelledby="ab-offer-title">
          <h2 id="ab-offer-title">Products and support, in one place.</h2>
          <div className="ab-grid">
            <article>
              <span className="ab-number" aria-hidden="true">
                01
              </span>
              <h3>Parts & accessories</h3>
              <p>
                Explore electronic components, bill acceptors, printers,
                monitors, and other gaming machine accessories.
              </p>
              <Link to="/products">Shop the catalogue →</Link>
            </article>
            <article>
              <span className="ab-number" aria-hidden="true">
                02
              </span>
              <h3>Technical services</h3>
              <p>
                Ask about installation, maintenance, repairs, or help
                identifying a suitable replacement part.
              </p>
              <Link to="/services">View our services →</Link>
            </article>
            <article>
              <span className="ab-number" aria-hidden="true">
                03
              </span>
              <h3>Gaming machines & leasing</h3>
              <p>
                Discuss assembly, machine availability, and leasing options with
                our team.
              </p>
              <Link to="/gaming-machines">Explore gaming machines →</Link>
            </article>
          </div>
        </section>
        <FactDice />
        <section className="ab-visit" aria-labelledby="ab-visit-title">
          <div>
            <p className="ab-eyebrow">LET’S TALK</p>
            <h2 id="ab-visit-title">Local support for your next step.</h2>
            <p>
              Visit us at Shop 4B, 17 Molynes Road, Kingston, Jamaica. Contact
              our team before travelling to confirm availability or arrange
              store pickup.
            </p>
            <div className="ab-visit-actions">
              <Link className="ab-primary" to="/contact">
                Contact & store details →
              </Link>
              <a href="https://www.google.com/maps/search/?api=1&query=Technogenious%20Solutions%20Ltd%2C%2017%20Molynes%20Road%2C%20Kingston%2C%20Jamaica" target="_blank" rel="noopener noreferrer">
                Open in Google Maps ↗
              </a>
            </div>
          </div>
          <StoreMap />
        </section>
      </div>
    </main>
  );
}
